import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type IntegrationOTC = z.output<typeof integrationOTCSchema>;
export type IntegrationOTCDTO = z.input<typeof integrationOTCSchema>;

export const integrationOTCSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  integrationId: z.string(),

  expiresAt: isoDatetimeToDate.optional(),

  token: z.string(),
});
